import { Box, Button, Grid, Typography } from '@mui/material';

export const ReservationCancelDone = (props: any) => {
  return (
    <Grid container direction={'row'} justifyContent="center">
      <Grid item xs={1} md={3} sm={2} />
      <Grid item xs={10} md={6} sm={8}>
        <Typography className="font-bold" textAlign={'center'} marginTop={5}>
          ご予約キャンセルを承りました。
        </Typography>
        <Typography textAlign={'center'} marginTop={3}>
          再度ご予約をおこなう場合は
          <br />
          予約ページから
          <br />
          診療メニューと日時を選択してください。
        </Typography>
        <Box display="flex" justifyContent="space-between">
          <Button
            className="bg-primary"
            variant="contained"
            fullWidth
            onClick={props.linkToMypage}
            sx={{ mt: 3, mb: 2 }}
          >
            <Typography className="text-white" sx={{ my: 0.5 }}>
              マイページへ戻る
            </Typography>
          </Button>
        </Box>
      </Grid>
      <Grid item xs={1} md={3} sm={2} />
    </Grid>
  );
};
